/* eslint import/prefer-default-export: 0 */

// dependencies
import { CreateProcess } from "redux-process";

export const Authenticate = CreateProcess({
	method: "POST",
	name: "Authenticate",
	type: "USERS:GET",

	request: (props) => ({
		url: "/auth/login/",
		payload: props.payload,
	}),

	success: (response) => ({
		didMfaLoginPass: response.data.mfaLoginPassed,
		isValid: response.data.valid,
		jwtPayload: response.data.payload,
	}),

	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});

export const AuthenticateGoogle = CreateProcess({
	method: "POST",
	name: "AuthenticateGoogle",
	type: "OAUTH:GET",

	request: (props) => ({
		url: "/auth/google/login",
		payload: props.payload,
	}),

	success: (response) => ({
		authUrl: response.data.authUrl,
	}),

	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});

export const AuthenticateGoogleCallback = CreateProcess({
	method: "GET",
	name: "AuthenticateGoogleCallback",
	type: "OAUTH:GET",

	request: (props) => ({
		url: `/auth/google/callback?code=${props.payload.code}`,
		payload: props.payload,
	}),

	success: (response) => ({
		isValid: response.data.valid,
	}),

	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});
